module.exports = __webpack_public_path__ + "static/media/phone.a7441ff8.jpg";